import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAccordion from './VaAccordion.vue'

export const VaAccordion = withConfigTransport(_VaAccordion)
